import axios from 'axios';


const url = process.env.REACT_APP_BASE_API_URL;

export function controlesenhaFindAll() {
    const headers = { 'Content-Type': 'application/json'}
    return axios.get(url + '/v1/controlesenha/findall', {headers});
}

export function controlesenhaInsert(usuario) {
  const headers = { 'Content-Type': 'application/json'};
  return axios.post(url + '/v1/controlesenha/insert', usuario, {headers});
}

export function controlesenhaUpdate(usuario) {
  const headers = { 'Content-Type': 'application/json'};
  return axios.put(url + '/v1/controlesenha/update', usuario, {headers});
}
    
export function controlesenhaDelete(usuario) {
  const headers = { 'Content-Type': 'application/json'};
  return axios.delete(url + '/v1/controlesenha/delete', {data: usuario}, {headers});
}
